const versionPublicadaInitialState = {
    versionPublicada: {
        loading: false,
        error: null,
        data: null
    },
};

export default versionPublicadaInitialState;